import { Loader } from "@dreamhub/designsystem/icons";
import { cn } from "@/utils/utils";
import React from "react";

export type SpinnerSize = "xs" | "sm" | "5" | "md" | "lg" | "xl";

// Sizes mirror IconContainer's vocabulary so loader call-sites can swap 1:1.
const sizeClasses: Record<SpinnerSize, string> = {
  xs: "size-3",
  sm: "size-4",
  "5": "size-5",
  md: "size-6",
  lg: "size-8",
  xl: "size-10"
};

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  size?: SpinnerSize;
}

/**
 * The single loading indicator for the app: the gradient comet ring (Loader.svg)
 * rendered in white. The SVG keeps its native stroke width (it is NOT routed
 * through IconContainer, whose stroke-width normalization is meant for outline
 * icons and crushes this gradient ring into a thin line).
 */
const Spinner: React.FC<Props> = ({ size = "5", className, ...divProps }) => (
  <div
    role="status"
    aria-label="loading"
    className={cn(
      "flex shrink-0 items-center justify-center text-on-surface [&>svg]:size-full",
      sizeClasses[size],
      className
    )}
    {...divProps}
  >
    <Loader />
  </div>
);

export default Spinner;
